import axios from "libs/axios";
import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { CheckoutDTO } from "../type";
import { useAppSelector } from "store";
interface checkoutRequest {
  PageNumber?: number;
  PageSize?: number;
  AcceptorCode: string;
}

const checkouts = async (data: checkoutRequest) => {
  return await axios
    .get<CheckoutDTO>(`/api/v1/SwitchTransaction/get-with-acceptor-code`, {
      params: { ...data, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const useCheckouts = (data: Omit<checkoutRequest, "AcceptorCode">) => {
  const shopAndAcceptor = useAppSelector((state) => state.shopAndAcceptor);
  return useQuery<CheckoutDTO, AxiosError>(
    [
      "/api/v1/SwitchTransaction/get-with-acceptor-code",
      data.PageNumber,
      shopAndAcceptor,
    ],
    async () =>
      checkouts({
        PageNumber: data.PageNumber,
        PageSize: data.PageSize,
        AcceptorCode: shopAndAcceptor.shaparakAcceptors?.acceptorCode || "",
      }),
    {
      enabled: !!shopAndAcceptor.shaparakAcceptors?.acceptorCode,
    }
  );
};

// curl -X 'GET' \
//   'http://192.168.150.186:8099/api/v1/SwitchTransaction/get-with-acceptor-code?AcceptorCode=079399007000002&PageNumber=1&PageSize=10' \
//   -H 'accept: */*'
